// import React, { useState, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaArrowRightToBracket } from "react-icons/fa6";
// import Pagination from "../../Components/Common/Pagination";
// import styles from "../../assets/scss/TransportHandlers/TransportHandlersBilling.module.scss";

// const TransportHandlersBilling = () => {
//   const navigate = useNavigate();

//   // 🔥 Pagination States
//   const [currentPage, setCurrentPage] = useState(1);
//   const [limit, setLimit] = useState(10);

//   // ✅ Static Data
//   const staticData = [
//     { _id: "1", customer: { firstName: "Suriya", phone: "9080706050" }, totalCreditAmount: 25000, walletBalance: 5000 },
//     { _id: "2", customer: { firstName: "Arun Kumar", phone: "9876543210" }, totalCreditAmount: 15000, walletBalance: 2000 },
//     { _id: "3", customer: { firstName: "Sathish", phone: "9123456780" }, totalCreditAmount: 32000, walletBalance: 7500 },
//     { _id: "4", customer: { firstName: "Karthi", phone: "9000000001" }, totalCreditAmount: 12000, walletBalance: 3000 },
//     { _id: "5", customer: { firstName: "Vijay", phone: "9000000002" }, totalCreditAmount: 45000, walletBalance: 10000 },
//     { _id: "6", customer: { firstName: "Ajith", phone: "9000000003" }, totalCreditAmount: 6000, walletBalance: 1500 },
//     { _id: "7", customer: { firstName: "Ramesh", phone: "9000000004" }, totalCreditAmount: 9800, walletBalance: 2400 },
//     { _id: "8", customer: { firstName: "Siva", phone: "9000000005" }, totalCreditAmount: 27500, walletBalance: 8000 },
//     { _id: "9", customer: { firstName: "Mani", phone: "9000000006" }, totalCreditAmount: 14000, walletBalance: 3500 },
//     { _id: "10", customer: { firstName: "Prakash", phone: "9000000007" }, totalCreditAmount: 18000, walletBalance: 4200 },
//     { _id: "11", customer: { firstName: "Bala", phone: "9000000008" }, totalCreditAmount: 22000, walletBalance: 6000 },
//   ];

//   // 🔥 Pagination Logic
//   const totalPages = Math.ceil(staticData.length / limit);

//   const paginatedData = useMemo(() => {
//     const start = (currentPage - 1) * limit;
//     return staticData.slice(start, start + limit);
//   }, [currentPage, limit, staticData]);

//   return (
//     <div className={styles.parent}>
//       <div className={styles.box}>
//         <div className={styles.tableWrapper}>
//           <table className={styles.table}>
//             <thead>
//               <tr>
//                 <th>Customer Name</th>
//                 <th>Phone</th>
//                 <th>Pending Credit</th>
//                 <th>Debit Balance</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>

//             <tbody>
//               {paginatedData.length > 0 ? (
//                 paginatedData.map((item) => (
//                   <tr key={item._id}>
//                     <td>{item.customer?.firstName || "N/A"}</td>
//                     <td className="notranslate">{item.customer?.phone || "N/A"}</td>
//                     <td className="notranslate">₹ {item.totalCreditAmount || 0}</td>
//                     <td className="notranslate">₹ {item.walletBalance || 0}</td>
//                     <td>
//                       <FaArrowRightToBracket
//                         onClick={() =>
//                           navigate(
//                             `/dashboard/TransportHandlersBillingView?id=${item._id}&mode=view`,
//                             { state: { activeTab: "transport" } }
//                           )
//                         }
//                         className={styles.icon}
//                       />
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="5" className={styles.noData}>
//                     No journal entries found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* ✅ PAGINATION */}
//         <div className={styles.paginationContainer}>
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onPageChange={setCurrentPage}
//           />

//           <select
//             value={limit}
//             className={styles.inputsbtn}
//             onChange={(e) => {
//               setLimit(Number(e.target.value));
//               setCurrentPage(1);
//             }}
//           >
//             <option value={10}>10 rows</option>
//             <option value={25}>25 rows</option>
//             <option value={50}>50 rows</option>
//           </select>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TransportHandlersBilling;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRightToBracket } from "react-icons/fa6";
import Pagination from "../../Components/Common/Pagination";
import styles from "../../assets/scss/TransportHandlers/TransportHandlersBilling.module.scss";
import { useGetTempEmployeeLedgerSummaryQuery } from "../../slices/admin/admin";
import { capitalize } from "../../utils/capitalize";

const TransportHandlersBilling = () => {
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // ✅ API CALL
  const { data, isLoading, isError } =
    useGetTempEmployeeLedgerSummaryQuery({
      offset: currentPage,
      limit,
    });

  const ledgerList = data?.data || [];
  const total = data?.total || 0;
  const totalPages = Math.ceil(total / limit);

  return (
    <div className={styles.parent}>
      <div className={styles.box}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Phone</th>
                <th>Pending Amount</th>
                <th>Debit Balance</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan="5">Loading...</td>
                </tr>
              ) : ledgerList.length > 0 ? (
                ledgerList.map((item) => (
                  <tr key={item.empId}>
                    <td>{item.name ? capitalize(item.name) : '-'}</td>
                    <td className="notranslate">{item.phone}</td>
                    <td className="notranslate">
                      ₹ {item.totalPendingAmount || 0}
                    </td>
                    <td className="notranslate">
                      ₹ {item.walletBalance || 0}
                    </td>
                    <td>
                      <FaArrowRightToBracket
                        onClick={() =>
                          navigate(
                            `/dashboard/TransportHandlersBillingView?id=${item.empId}`
                          )
                        }
                        className={styles.icon}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className={styles.noData}>
                    No ledger found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div className={styles.paginationContainer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            value={limit}
            className={styles.inputsbtn}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default TransportHandlersBilling;